import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "withdraw-history"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "提现时间", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置");

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import { getVexTableProps } from '@/config';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'withdraw',

  setup(__props) {
    onMounted(() => getSupplierList());
    const route = useRoute();
    const status = {
      1: '提现中',
      2: '提现成功',
      3: '提现失败'
    };
    const search = ref({
      supplierId: '',
      participateName: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '提现单号',
        field: 'withdrawNo'
      }, {
        title: '提现方',
        field: 'participateName'
      }, {
        title: '提现金额',
        field: 'withdrawAmount'
      }, {
        title: '提现手续费（元）',
        field: 'withdrawFeeAmount'
      }, {
        title: '处理状态',
        field: 'withdrawStatus',
        slots: {
          default: 'withdrawStatus'
        }
      }, {
        title: '操作人/审核人',
        field: 'createMan'
      }, {
        title: '提现时间',
        field: 'withdrawTime'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            return new Promise(resolve => {
              let {
                participateId,
                participateRole,
                isOnlineCreditPay,
                withdrawRecordIds
              } = route.query;

              let params = _objectSpread({
                page: page.currentPage,
                pageSize: page.pageSize,
                participateId,
                participateRole,
                isOnlineCreditPay,
                withdrawRecordIds
              }, search.value);

              console.log(dateRange.value);

              if (dateRange.value && dateRange.value.length) {
                params.withdrawStartTime = dateRange.value[0], params.withdrawEndTime = dateRange.value[1];
              }

              Axios.get('/admin/split/withdraw/recordList.json', {
                params
              }).then(res => {
                if (!res.data.success) return;
                resolve({
                  total: res.data.data.total,
                  result: res.data.data.list
                });
              });
            });
          }
        }
      }
    });
    const dateRange = ref([]);
    const supplierList = ref([]);

    function getSupplierList() {
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    function reset() {
      search.value = {
        supplierId: '',
        participateName: ''
      };
      dateRange.value = [];
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dateRange.value = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        style: {
          "flex": "0 0 300px"
        },
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      })])]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        withdrawStatus: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(status[row.withdrawStatus]), 1)]),
        _: 1
      }, 16)]);
    };
  }

};